import Avatar from '@material-ui/core/Avatar';
import Chip from '@material-ui/core/Chip';
import Icon from '@material-ui/core/Icon';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
import {
  accentForCurrency,
  multiplyValueForCurrency,
} from 'utils/currency/currency-utils';
import '../../index.scss';
import { getCellContents, getVenueSteps } from '../../TableCellGenerator';

class PendingBookingsTableRow extends React.Component {
  remindBooking = (e, booking) => {
    e.preventDefault();
    e.stopPropagation();

    this.props.remindPendingBooking(booking);
  };

  render() {
    const { booking, venue } = this.props;
    const steps = getVenueSteps(venue);

    const showTime = steps.hasBookingTime;
    const bookingTime = moment(booking.booking_time).utc();

    const forceDeposit = (booking.force_deposit || {}).amount || 0;

    const formattedDate = showTime
      ? `${bookingTime.format('MM/DD/YYYY')}<br/>${bookingTime.format('HH:mm')}`
      : bookingTime.format('MM/DD/YYYY');
    const formattedDeposit = `${accentForCurrency(venue.currency)}${(
      forceDeposit / multiplyValueForCurrency(venue.currency)
    ).toFixed(2)}`;

    const isDraft = booking.draft;
    const rowClass = isDraft ? 'booking__row__pending' : '';

    return (
      <TableRow
        hover
        className="hover"
        onClick={isDraft ? null : this.props.onClick}
      >
        <TableCell
          data-label="Date"
          key={`p${booking.id || booking.draft_timestamp}time`}
          className={`${rowClass} pending__booking__time__cell`}
          dangerouslySetInnerHTML={{ __html: formattedDate }}
        />
        <TableCell
          data-label="Contact"
          key={`p${booking.id || booking.draft_timestamp}contact`}
          className={`${rowClass} contact__cell`}
          dangerouslySetInnerHTML={{
            __html: getCellContents('contact__cell', booking, venue.currency),
          }}
        />
        <TableCell
          data-label="Amount"
          key={`p${booking.id || booking.draft_timestamp}deposit`}
          className={`${rowClass} pending__deposit__cell`}
        >
          {formattedDeposit}
        </TableCell>
        <TableCell
          data-label="Actions"
          key={`p${booking.id || booking.draft_timestamp}actions`}
          className={`${rowClass} pending__actions__cell`}
        >
          {!isDraft && (
            <Chip
              onClick={e => this.remindBooking(e, booking)}
              label="Resend Email & SMS"
              avatar={
                <Avatar
                  className="pending__actions__reminder"
                  children={
                    <Icon className="pending__actions__reminder__icon">
                      send
                    </Icon>
                  }
                />
              }
            />
          )}
          {isDraft && <span>Uploading...</span>}
        </TableCell>
      </TableRow>
    );
  }
}

PendingBookingsTableRow.propTypes = {
  venue: PropTypes.object.isRequired,
  booking: PropTypes.object.isRequired,
  remindPendingBooking: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default PendingBookingsTableRow;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panels/Bookings/ViewBookingsPanel/PendingBookingsTable/PendingBookingsTableRow/index.jsx